module.exports = __webpack_public_path__ + "static/media/ploni-black-aaa.97e75ac1.woff";